/** @format */
import React, { useEffect, useState } from 'react';
import {
  SimpleDialog,
  ExportButton,
  FilterPod,
  LoadingPage,
  Empty,
  Icons
} from 'components';
import { useStyles } from './style';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import jMoment from 'moment-jalaali';
import persify from 'persify';
import { FILTER_TYPES } from 'components/FilterPod';
import { Box, Button, Grid } from '@mui/material';
import { useBusiness, useExportFile } from 'hooks';
import { URL_PODIUM } from 'config';
import { enifyDateTime } from 'utility';
import { Pagination } from '@mui/material';
import {
  requestedServiceSetApi,
  getRequestedServicesApi,
  generateApiKeyApi,
  deleteApiKeyApi,
} from '../services/ReportRequestedServices';
import { columns, columnsId } from './components/Columns';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';
import axios from 'axios';
import {
  getExport1499Url,
  getExportRequestedServiceUrl
} from 'URLs';
const COUNT_DATA_PER_PAGE = 20;

const ReportUsed = () => {
  const { downloadFile, isExporting } = useExportFile({
    url: getExport1499Url(),
    filename: 'request-used',
  });
  const { downloadFile: downloadFileDetail, isExporting: isExportingDetail } = useExportFile({
    url: getExportRequestedServiceUrl(),
    filename: 'request-used-detail',
  });

  const businessInfo = useBusiness();
  const actionsList =
    getDynamicObjectAction([
      'exportRequestListBtn',
    ])
  const classes = useStyles();

  const [listFilters, setListFilters] = useState([
    {
      title: 'محدوده تاریخ و زمان وقوع',
      label: {
        start: 'از تاریخ',
        end: 'تا تاریخ',
      },
      keyName: 'eqDateTimeRange',
      id: 1116,
      value: {
        start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
        end: jMoment(new Date().setHours(23, 59, 0, 0)),
      },
      filterType: FILTER_TYPES.dateRange,
      filterProps: {
        start: {},
        end: {},
      },
    },
  ]);

  const [filterParams, setFilterParams] = useState(null);

  const [detailFilterParams, setDetailFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [invoiceId, setInvoiceId] = useState();
  const [dialogContent, setDialogContent] = useState({
    title: '',
    content: '',
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [serviceSetList, setServiceSetList] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [txtNoData, setTxtNoData] = useState('موردی یافت نشد!');

  const [loading, setLoading] = useState(false);

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const [totalCount, setTotoalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const onExport = (type, index) => {
    const types = ['xls', 'csv'];

    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };
  // GET Service Set List
  const getDataServiceSet = async (page = 0) => {
    // TODO: Test Page No.
    const params = {
      page,
      size: COUNT_DATA_PER_PAGE,
    };
    const data = {
      filterVOS: [],
      parentParams: [
        {
          key: 'START_DATE',
          value: enifyDateTime(listFilters[0]?.value?.start?.format('jYYYY/jMM/jDD HH:mm:ss')),
        },
        {
          key: 'END_DATE',
          value: enifyDateTime(listFilters[0]?.value?.end?.format('jYYYY/jMM/jDD HH:mm:ss')),
        },
      ],
      orderByElementVOS: [],
    };

    try {
      setLoading(true);
      setFilterParams({ data, params });
      const res = await requestedServiceSetApi(data, params);
      setLoading(false);
      if (res.result.rows.length) {
        setServiceSetList(res.result.rows);
      }
    } catch (error) {
      setLoading(false);
      setTxtNoData('خطا در دریافت داده');
    }
  };

  const onExportDetail = async (type) => {
    downloadFileDetail(type, detailFilterParams?.data, detailFilterParams?.params);
  };

  // GET Service List
  const getDataServiceList = async (query) => {
    let orderBy = [];
    const filter = [];

    if (query?.filters?.length) {
      query.filters.forEach((row) => {
        if (row.column.field === 'status' && row.value === 'all') {
          return;
        }
        filter.push({
          id: columnsId[row.column.field],
          value: row.value,
        });
      });
    }

    if (query?.orderBy) {
      const desc = query.orderDirection === 'desc';
      if (query?.orderBy.field === 'dateTime') {
        orderBy = [
          {
            columnNumber: 2,
            desc,
          },
          {
            columnNumber: 3,
            desc,
          },
        ];
      } else {
        orderBy = [
          {
            columnNumber: 5,
            desc,
          },
        ];
      }
    }

    const params = {
      page: query ? query?.pageNumber : page,
      size: query?.pageSize || size,
      id: invoiceId,
    };

    const data = {
      filterVOS: filter ?? [],
      parentParams: [],
      orderByElementVOS: orderBy ?? [],
    };

    try {
      setDetailFilterParams({ data, params });
      const res = await getRequestedServicesApi(data, params);

      if (res.result.rows) {
        const data = res.result.rows.map((row, key) => ({
          num: persify(query?.page * query?.pageSize + key + 1),
          requestId: row.cols[0], // شناسه درخواست
          serviceId: row.cols[1],
          serviceName: row.cols[2],
          dateTime: row.cols[3],
          serviceProvider: row.cols[4],
          status: row.cols[5],
          clientId: row.cols[6],
        }));
        return {
          data,
          page: query ? query?.pageNumber : page,
          totalCount: res.result.totalCount,
        };
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  const deleteService = async (rowData, confirm = false) => {
    if (!confirm) {
      setDialogContent({
        content: `آیا از حذف  سرویس "<b>${rowData.serviceName}</b>" اطمینان دارید؟`,
        title: 'حذف سرویس',
      });
      setOpenDialog(true);
      setSelectedRow(rowData);
      return;
    }

    try {
      const params = {
        productId: selectedRow.serviceId,
      };
      await deleteApiKeyApi(params, selectedRow.requestId);
    } catch (error) {
      // TODO:: notification error
    }
  };

  const [expanded, setExpanded] = useState();

  const handleChange = (panel) => {
    setExpanded(invoiceId == panel ? null : panel);
    setInvoiceId(invoiceId == panel ? null : panel);
  };

  useEffect(() => {
    getDataServiceSet();
  }, [listFilters]);

  const applyFilters = (newF) => {
    setListFilters(newF);
  };

  const generateApiKey = async (serviceId) => {
    try {
      const data = {
        businessId: businessInfo.id,
      };
      const res = await generateApiKeyApi(data, serviceId);

      if (res.result?.apiKey) {
        setDialogContent({
          title: 'دریافت Api Key سرویس',
          content: res.result.apiKey,
        });
        setOpenDialog(true);
      }
    } catch (e) { }
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button variant="contained" onClick={closeDialog}>
          انصراف
        </Button>
        <Button onClick={() => deleteService('', true)}>تایید</Button>
      </>
    );
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const serviceSetLink = (event, id) => {
    event.stopPropagation();
    window.open(`${URL_PODIUM}/services/${id}`, '_blank');
  };

  const paginationOnChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
    getDataServiceSet(pageNumber - 1);
  };

  return (
    <>
      <SimpleDialog
        title={dialogContent.title}
        open={openDialog}
        onClose={closeDialog}
        actions={<ActionsBtn />}
      >
        <b>
          <div style={{ fontFamily: 'Vazir', textAlign: 'left', padding: 8 }}>
            {dialogContent.content ?? '-'}
          </div>
        </b>
      </SimpleDialog>
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ margin: "16px 0" }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={listFilters}
          />
          {actionsList['exportRequestListBtn'] && (
            <ExportButton
              loading={isExporting}
              types={['xls', 'csv']}
              onExport={onExport}
            />
          )}
        </Box>
        <Box>
          <FilterPod
            forceShowChips
            hideSelect
            filters={listFilters}
            onChange={applyFilters}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>

      {loading ? <LoadingPage /> : null}
      {!loading ? (
        serviceSetList.length ? (
          <>
            {serviceSetList.map((row, k) => (
              <React.Fragment key={k}>
                <Accordion
                  expanded={expanded === row.cols[5]}
                  className={classes.accordian}
                  onChange={() => { }}
                >
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    className={classes.header}
                    id="panel1a-header"
                  >
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Grid item xs={12} md={3} className={classes.keyTitlePart}>
                        <Typography variant="h5" className={classes.keyTitle}>
                          {row.cols[1]}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={3} className={classes.clientPart}>
                        <Typography variant="h5" className={classes.clientTitle}>
                          سرویس‌دهنده
                        </Typography>
                        <Typography variant="h6" className={classes.clientDesc}>
                          {row.cols[4] ?? '-'}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={3} className={classes.clientPart}>
                        <Typography variant="h5" className={classes.clientTitle}>
                          تاریخ
                        </Typography>
                        <Typography variant="h6" className={classes.clientDesc}>
                          {row.cols[2] ?? '-'}
                        </Typography>
                      </Grid>
                      <Button
                        startIcon={
                          expanded !== row.cols[5] ? < Icons icon="MoreHorizontal" color="#667585" size="20" />
                            : < Icons icon="CaretDown" color="#667585" size="20" />
                        }
                        variant="contained"
                        className={classes.expandBtn}
                        onClick={() => handleChange(row.cols[5])}
                      >
                        {expanded === row.cols[5] ? 'بستن جزئیات' : 'جزئیات درخواست'}
                      </Button>
                      <Button
                        color="primary"
                        style={{ marginInlineEnd: 8, marginInlineStart: 8 }}
                        variant="outlined"
                        className={classes.viewSiteButton}
                        onClick={(event) => serviceSetLink(event, `${row.cols[0]}/${row.cols[1]}`)}
                      >
                        لینک
                      </Button>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails>
                    {expanded === row.cols[5] && (
                      <Grid container>
                        <Grid item xs={12}>
                          <Grid
                            container
                            justifyContent="flex-end"
                            style={{ marginBottom: 16, marginInlineEnd: 16 }}
                          >
                            <ExportButton
                              loading={isExportingDetail}
                              types={['xls', 'csv']}
                              onExport={onExportDetail}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>


                          <TableComponents
                            data={getDataServiceList}
                            columns={columns(generateApiKey, deleteService)}
                            isLoading={loading}
                            onChange={(ps) => {
                              setPage(ps?.pageNumber)
                              setSize(ps?.pageSize)
                              return getDataServiceList(ps)
                            }}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </AccordionDetails>
                </Accordion>
              </React.Fragment>
            ))}
            <div className={classes.pagination}>
              <Pagination
                count={Math.ceil(totalCount / COUNT_DATA_PER_PAGE)}
                page={currentPage}
                onChange={paginationOnChange}
                color="primary"
              />
            </div>
          </>
        ) : (
          <div>{!txtNoData?.includes('خطا') ? <Empty /> : txtNoData}</div>
        )
      ) : null}
    </>
  );
};

export default ReportUsed;
